/*
 * Jira Ticket:
 * Created Date: Wed, 15th Apr 2020, 09:01:02 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getOneUserQuery = gql`
  query User($id: ID!) {
    data: User(id: $id) {
      id
      email
      familyName
      givenName
      position
      certificateNumber
      isAdmin
      hasAccount
      status
    }
  }
`;
